﻿$.fn.dxCtrlFichier2LstThumb = function custom_dxCtrlFichier2LstThumb(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2lstthumb dx-ctrl");
        this.createInstance(new cdxCtrlFichier2LstThumb(this, option));
    }
    return this;
}

window.cdxCtrlFichier2LstThumb = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.margin == 'undefined') option.margin = 0

    var dxScroll = null
    var $DivBt = null
    var dxBtDownload = null
    var dxBtDownloadZip = null
    var btAddFile = null
    var dxBtDeleteAll = null
    function mConstruit() {
        container.empty();
        container.css({
            "height": "100%",
            "width": "100%",
            "position": "relative",
            "font-family": "Barlow Condensed"
        })

        dxScroll = $("<div style='height:100%;'/>").appendTo(container).dxCtrlScrollView({}).dxCtrlScrollView("instance")
        $DivBt = $("<div style='text-align:center;padding:5px;'/>").appendTo(container)
        var $Table = $("<table style='width:100%'/>").appendTo($DivBt)
        var $Tr = $("<tr/>").appendTo($Table)

        if (typeof option.onDemandeAddFiles != 'undefined' && !option.readOnly) {
            var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
            btAddFile = $("<div style='display:inline-block;padding-right:5px;'/>").appendTo($Td).dxCtrlButton({
                height: 40,
                width: 40,
                icon: "fas fa-paperclip",
                icon2: "fas fa-plus",
                txtTooltip: "Ajouter des fichiers",
                onClick: function (e) {
                    option.onDemandeAddFiles()
                }
            }).dxCtrlButton("instance")
        }

        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)

        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        dxBtDownload = $("<div style='display:inline-block;padding-right:5px;'/>").appendTo($Td).dxCtrlButton({
            height: 40,
            width: 40,
            icon: "fas fa-cloud-arrow-up",
            txtTooltip: "Télécharger chaque fichier",
            onClick: function (e) {
                option.dataSource.forEach(function (item) {
                    mDownLoadFile(option.bddCtrl, item.url)
                })
            }
        }).dxCtrlButton("instance")
        dxBtDownload.mRempliCompteur(option.dataSource.length)
        if (option.dataSource.length == 0) dxBtDownload.element().hide()
        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        dxBtDownloadZip = $("<div style='display:inline-block;padding-right:5px;'/>").appendTo($Td).dxCtrlButton({
            height: 40,
            width: 40,
            icon: "fas fa-cloud-arrow-up",
            icon2: "fas fa-file-zipper",
            txtTooltip: "Télécharger les fichiers dans une archive compressée",
            onClick: function (e) {
                lstUrl = []
                option.dataSource.forEach(function (item) { lstUrl.push({ url: item.url }) });
                option.bddCtrl.mAjaxCall({ command: "compressfilesansthread", lstUrl: lstUrl }, function (data) {
                    mDownLoadFile(option.bddCtrl, data.urlzip);
                })
            }
        }).dxCtrlButton("instance")
        dxBtDownloadZip.mRempliCompteur(option.dataSource.length)
        if (option.dataSource.length == 0) dxBtDownloadZip.element().hide()

        if (typeof option.onDeleteAllFiles != 'undefined' && !option.readOnly) {
            var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
            dxBtDeleteAll = $("<div style='display:inline-block;padding-right:5px;'/>").appendTo($Td).dxCtrlButton({
                height: 40,
                width: 40,
                icon: "fas fa-trash-alt",
                txtTooltip: "Supprimer tous les fichiers",
                onClick: function (e) {
                    e.event.stopPropagation()
                    var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                        target: e.component.element(),
                        contentTemplate: function (contentElement) {
                            contentElement.css("padding", "24px");
                            $("<div style='padding-bottom:15px;'>Supprimer tous les fichiers.</div>").appendTo(contentElement)
                            $("<div style='padding-top:10px;'/>").appendTo(contentElement).dxCtrlButton({
                                text: "Confirmer",
                                width: "100%",
                                onClick: function (e) {
                                    option.onDeleteAllFiles()
                                    tt.hide()
                                }
                            }).dxCtrlButton("instance")
                        }
                    }).dxCtrlTooltip("instance");
                    tt.show()
                }
            }).dxCtrlButton("instance")
            dxBtDeleteAll.mRempliCompteur(option.dataSource.length)
            if (option.dataSource.length == 0) dxBtDeleteAll.element().hide()
        }


        dxScroll.element().css("height", "calc(100% - " + $DivBt.innerHeight() + "px)")
        resizeObserver.mAdd($DivBt, function () { dxScroll.element().css("height", "calc(100% - " + $DivBt.innerHeight() + "px)") })
        dxScroll.content().css("padding", "0 10px 0 10px")

        if (typeof option.onReorder != 'undefined' && !option.readOnly) {
            dxScroll.content().dxSortable({
                group: 'items',
                moveItemOnDrop: true,
                onReorder: function (e) {
                    debugger;
                    var itemData = option.dataSource[e.fromIndex]
                    option.dataSource.move(e.fromIndex, e.toIndex)
                    lstCtrlThumb.move(e.fromIndex, e.toIndex)
                    option.onReorder(itemData)
                }
            });
        }

        mRempli()
    }

    var lstCtrlThumb = []
    function mRempli() {
        dxScroll.content().empty()
        lstCtrlThumb = []
        if (option.dataSource.length == 0) {
            $("<div style='display:flex;align-items:center;justify-content:center;height:100%;padding-top:50px;'>Aucun fichier</div>").appendTo(dxScroll.content())
        } else {
            option.dataSource.forEach(function (item, idx) {
                mAddItem(item, idx)
            })
        }
    }

    var paddingItem = "8px 15px 22px 15px"
    function mAddItem(itemData, idx) {
        var ctrlThumb = $("<div style='width:100%;padding:" + paddingItem + ";' class='itemfile'/>").appendTo(dxScroll.content()).dxCtrlFichier2LstThumbItem({
            bddCtrl: option.bddCtrl,
            itemData: itemData,
            onClick: function (itemData) {
                Me.mSelect(itemData)
            }
        }).dxCtrlFichier2LstThumbItem("instance")
        lstCtrlThumb.push(ctrlThumb)
        if ((typeof option.selectedItem != 'undefined' && option.selectedItem != null && option.selectedItem == itemData) || ((typeof option.selectedItem == 'undefined' || option.selectedItem ==null) && idx==0)) {
            ctrlThumb.element().css("background-color", theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",1)"))
            window.setTimeout(function () {
                dxScroll.smoothScrollTo(ctrlThumb.element().position().top - (dxScroll.clientHeight() - ctrlThumb.element().innerWidth()) / 2)
            }, 400)
        }
        ctrlThumb.element().on("mouseenter", function () {
            ctrlThumb.element().css("box-shadow", "0px 0px 10px 0px #ffffff")
        })
        ctrlThumb.element().on("mouseleave", function () {
            ctrlThumb.element().css("box-shadow", "none")
        })
    }

    this.mSelect = function (itemData) {
        if (option.dataSource.length > 0) {
            dxBtDownload.element().show()
            dxBtDownloadZip.element().show()
            if (dxBtDeleteAll) dxBtDeleteAll.element().show()
        } else {
            dxBtDownload.element().hide()
            dxBtDownloadZip.element().hide()
            if (dxBtDeleteAll) dxBtDeleteAll.element().hide()
        }
        dxBtDownload.mRempliCompteur(option.dataSource.length)
        dxBtDownloadZip.mRempliCompteur(option.dataSource.length)
        if (dxBtDeleteAll) dxBtDeleteAll.mRempliCompteur(option.dataSource.length)

        if (typeof itemData == 'undefined' || itemData == null) {
            if (typeof option.onSelectionChanged != 'undefined') option.onSelectionChanged(itemData)
        } else {
            var ctrlThumbSelected = null
            lstCtrlThumb.forEach(function (ctrlThumb) {
                if (itemData == ctrlThumb.option("itemData")) {
                    ctrlThumbSelected = ctrlThumb
                    ctrlThumb.element().css("background-color", theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",1)"))
                } else {
                    ctrlThumb.element().css("background-color", theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",0)"))
                }
            })
            if (typeof option.onSelectionChanged != 'undefined') option.onSelectionChanged(itemData)
            if (ctrlThumbSelected) {
                window.setTimeout(function () {
                    dxScroll.smoothScrollTo(ctrlThumbSelected.element().position().top - (dxScroll.clientHeight() - ctrlThumbSelected.element().innerWidth()) / 2)
                }, 400)
            }
        }
    }

    this.mAddNewItemData = function (lstNewItemData) {
        lstNewItemData.forEach(function (newItemData) {
            var idx = option.dataSource.indexOf(newItemData)
            mAddItem(newItemData, idx)
        })
        this.mSelect(option.dataSource[option.dataSource.length - 1], option.dataSource.length - 1)
    }

    this.mRemoveThumbItemData = function (itemData) {
        var ctrlThumb = lstCtrlThumb[option.dataSource.indexOf(itemData)]
        lstCtrlThumb.splice(option.dataSource.indexOf(itemData), 1)
        ctrlThumb.element().remove()
    }

    this.mClear = function () {
        lstCtrlThumb.forEach(function (ctrlThumb) { ctrlThumb.element().remove() })
        lstCtrlThumb = []
    }

    this.element = function () { return container }

    mConstruit();
}